<style src="./SerproConfig.scss" lang="scss"></style>
<template>
  <div class="SerproConfig wrapper wrapper-content animated fadeIn">
    <div class="mail-box-header">
      <div class="row">
        <h2>Informações Administrativas</h2>
        <div class="space-25"></div>
        <div class="row">
          <div class="form-group col-lg-4">
            <label>Código do Município</label>
            <input
              type="text"
              class="form-control"
              v-model="form.tomMunicipio"
            />
          </div>
          <div class="form-group col-lg-4">
            <label>Código do Órgão</label>
            <input
              type="text"
              class="form-control"
              v-model="form.orgaoCodigo"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="space-25"></div>
        <h2>Informações Padrão da Multa</h2>
        <div class="space-25"></div>
        <div class="row">
          <div class="form-group col-lg-2">
            <label>Enquadramento Padrão</label>
            <input
              type="text"
              class="form-control"
              v-model="form.infracaoCodigo"
            />
          </div>
          <div class="form-group col-lg-2">
            <label>Desdobramento Padrão</label>
            <input
              type="text"
              class="form-control"
              v-model="form.infracaoDesdobramento"
            />
          </div>
          <div class="form-group col-lg-2">
            <label>Observação Padrão</label>
            <textarea
              class="form-control"
              v-model="form.observation"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="space-25"></div>
        <h2>Informações dos Últimos Registros</h2>
        <div class="space-25"></div>

        <div class="row">
          <!-- <div class="form-group col-lg-4">
            <label>Lote Atual</label>
            <input
              type="text"
              class="form-control"
              v-model="form.currentLot"
            />
          </div> -->
          <div class="form-group col-lg-4">
            <label>Prefixo do AIT</label>
            <input
              type="text"
              class="form-control"
              v-model="form.AITPrefix"
            />
          </div>
          <div class="form-group col-lg-4">
            <label>Último AIT</label>
            <input
              type="text"
              class="form-control"
              v-model="form.lastAIT"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="space-25"></div>
        <h2>Dados da API da Serpro</h2>
        <div class="space-25"></div>

        <div class="row">
          <div class="form-group col-lg-4">
            <label>Escopo</label>
            <input
              type="text"
              class="form-control"
              v-model="form.escopo"
            />
          </div>
          <div class="form-group col-lg-4">
            <label>Consumer Key</label>
            <input
              type="text"
              class="form-control"
              v-model="form.consumerKey"
            />
          </div>

          <div class="form-group col-lg-4">
            <label>Consumer Secret</label>
            <input
              type="text"
              class="form-control"
              v-model="form.consumerSecret"
            />
          </div>

          <div class="form-group col-lg-6">
            <label>URL de autenticação</label>
            <input
              type="text"
              class="form-control"
              v-model="form.urlAuthentication"
            />
          </div>

          <div class="form-group col-lg-6">
            <label>URL do status do veículo</label>
            <input
              type="text"
              class="form-control"
              v-model="form.urlVehicleStatus"
            />
          </div>
          <div class="form-group col-lg-6">
            <label>URL do status do CPF</label>
            <input
              type="text"
              class="form-control"
              v-model="form.urlCpfConsultation"
            />
          </div>
          <div class="form-group col-lg-6">
            <label>URL para envio da infração</label>
            <input
              type="text"
              class="form-control"
              v-model="form.urlInfractionsSend"
            />
          </div>
          <div class="form-group col-lg-6">
            <label>URL do status da infração</label>
            <input
              type="text"
              class="form-control"
              v-model="form.urlInfractionsStatus"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="mail-box-header">
          <button class="btn btn-primary" type="button" @click="save" :disabled="isDisabled">
            Salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toast } from '@/plugins/toast';
export default {
  name: 'GuardConfig',
  data() {
    return {
      isDisabled: false,
      form: {
        tomMunicipio: '',
        orgaoCodigo: '',
        infracaoCodigo: '',
        infracaoDesdobramento: '',
        currentLot: 0,
        lastAIT: 0,
        AITPrefix: '',
        serpro: {
          escopo: '',
          consumerKey: '',
          consumerSecret: '',
          urlAuthentication: '',
          urlVehicleStatus: '',
          urlCpfConsultation: '',
          urlInfractionsSend: '',
          urlInfractionsStatus: '',
          observation: ''
        }
      },
    };
  },
  mounted() {
    this.loadGuardConfig();
  },
  methods: {
    async loadGuardConfig() {
      const guardConfig = await this.$store.dispatch(
        'GUARD-REQUEST/GetGuardConfig',
      );
      if (guardConfig.config.serpro) {
        this.form.tomMunicipio = guardConfig.config.serpro.tomMunicipio;
        this.form.orgaoCodigo = guardConfig.config.serpro.orgaoCodigo;
        this.form.infracaoCodigo = guardConfig.config.serpro.infracaoCodigo;
        this.form.infracaoDesdobramento = guardConfig.config.serpro.infracaoDesdobramento;

        this.form.escopo = guardConfig.config.serpro.escopo;
        this.form.consumerKey = guardConfig.config.serpro.consumerKey;
        this.form.consumerSecret = guardConfig.config.serpro.consumerSecret;
        this.form.urlAuthentication = guardConfig.config.serpro.urlAuthentication;
        this.form.urlVehicleStatus = guardConfig.config.serpro.urlVehicleStatus;
        this.form.urlCpfConsultation = guardConfig.config.serpro.urlCpfConsultation;
        this.form.urlInfractionsSend = guardConfig.config.serpro.urlInfractionsSend;
        this.form.urlInfractionsStatus = guardConfig.config.serpro.urlInfractionsStatus;
        this.form.observation = guardConfig.config.serpro.observation;

      }
      this.form.currentLot = guardConfig.config.fileName.currentLot;
      this.form.lastAIT = guardConfig.config.row.lastAIT;
      this.form.AITPrefix = guardConfig.config.row.AITPrefix;
    },
    async save() {
      this.isDisabled = true;
      try {
        await this.$store.dispatch(
          'SERPRO/UpdateSerproConfig',
          this.form,
        );
        toast.success('Salvo com sucesso');
      } catch (error) {
        toast.error('Não foi possível salvar');
      } finally {
        this.isDisabled = false;
      }
    },
  },
};
</script>
